<!-- 文章发布列表页 -->
<template>
	<div>
		<el-card class="box-card set-card" style="position: relative">
			<div class="box-top"></div>
			<div class="newsList-box">
				<div class="newsItem" @click="toParticulars(false, item)" v-for="(item, index) in articleData" :key="index">
					<div class="img-content-box">
						<el-image :src="item.outPicture" class="img-box">
							<div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
						</el-image>
<!--						<div class="small-title" style="">-->
<!--							<span>{{ item.nowTypeName }}-{{ item.typeName }}</span>-->
<!--						</div>-->
					</div>
					<div class="content">
						<div class="content-top">
							<h5 class="content-title">{{ item.title }}</h5>
							<p class="hint-text" v-html="$options.filters.checkVal(item.content)"></p>
						</div>
						<div class="content-bottom">
							<span>{{ item.updateTime }}</span>
							<el-button>编辑</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-card>
		<!-- 分页-->
		<el-row type="flex" justify="center">
			<el-col :span="24" class="nomore" style="margin-top: 24px">
				<!-- <span v-if="isShow">没有更多了</span> -->
				<el-pagination
					class="page"
					background
					:current-page="currentPage"
					@current-change="current_page"
					layout="total, prev, pager, next, jumper"
					:total="dataNumber"
				>
				</el-pagination>
			</el-col>
		</el-row>
		<!-- end -->
	</div>
</template>
<script>
	export default {
		data() {
			return {
				page: 1,
				size: 10,
				type: "", // 1新闻通告    0求职须知
				dataNumber: 0, // 有多少条数据
				currentPage: 1,
				typeData: [
					{
						value: "",
						label: "全部",
					},
					{
						value: "0",
						label: "求职须知",
					},
					{
						value: "1",
						label: "新闻通告",
					},
				],
				articleData: [],
				options: [],
			};
		},
		methods: {
			// 小程序新闻树
			getTree() {
				this.axiosGet(`/common/findSysDictByNewsNoticeTree?code=${"journalism_menu"}`).then((res) => {
					if (res.code == 200) {
						this.options = res.data;
					}
				});
			},
			// 选择类型
			handlechange(data) {
				var data1 = data.slice(-1);
				let grouping = data1.toString();
				this.Typeid = grouping;
			},
			// 页面跳转到文章详情
			toParticulars(status, data) {
				if (data) {
					// publicVue.articleInfo = data;
					this.$router.push({
						name: "addArticle",
						params: {
							data: data,
						},
					});
				} else {
					// publicVue.articleInfo = "";
					this.$router.push({
						name: "addArticle",
					});
				}
				this.$emit("statusFun", status);
			},
			// 分页
			current_page(currentPage) {
        console.log(currentPage)
				this.page = currentPage;
				this.getAricleFn();
			},
			// 获取文章列表
			getAricleFn() {
				this.axiosGet("/newsNotice/selectByType", {
					params: {
						type: this.type,
						page: this.page,
						size: this.size,
						isHomePage: 1,
					},
				}).then((res) => {
					if (res.code == 200) {
						this.articleData = res.data.list;
						this.dataNumber = res.data.total;
					}
				});
			},
		},
		filters: {
			checkVal(str) {
				let reg1 =
					/<img.*?>|<p>|<\/p>|<u>|<\/u>|<strong>|<\/strong>|<em>|<\/em>|<h1>|<\/h1>|<h2>|<\/h2>|<sub>|<\/sub>|<span.*?<\/span>|<sup>|<\/sup>|<h1.*?>|<sup.*?>/gi;
				str = str.replace(reg1, "").substring(0, 200);
				return str;
			},
		},
		created() {
			this.getAricleFn();
			this.getTree();
		},
		updated() {},
	};
</script>
<style lang="less" scoped>
	// 分页
	.box-card {
	  .box-top {
	    padding: 36px 32px 0 30px;
	    display: flex;
	    justify-content: space-between;
	    margin-bottom: 8px;

	    .sendNewsBtn {
	      width: 136px;
	      height: 48px;
	      border: 2px solid #1A80FC;
	      border-radius: 8px;
	      background: #fff;
	      color: #1A80FC;
	    }
	  }

	  .newsList-box {

	    .newsItem:hover {
	      box-shadow: 0px 3px 19px 5px rgba(42, 112, 255, 0.13);
	    }

	    .newsItem {
	      transition: .2s;
	      padding: 25px 30px 0 30px;
	      display: flex;
	      padding-bottom: 48px;
	      cursor: pointer;

	      .img-content-box {
	        position: relative;

	        .img-box {
	          width: 260px;
	          height: 194px;
	          border-radius: 8px;
	        }
	      }

	      .content {
	        width: 761px;
	        height: 194px;
	        margin-left: 17px;
	        display: flex;
	        flex-direction: column;
	        position: relative;

	        .content-top {
	          .content-title {
	            font-size: 24px;
	            font-weight: bold;
	            color: #333333;
	            text-align: left;
	            line-height: 24px;
	            margin-bottom: 18px;
	          }

	          .hint-text {
	            font-size: 14px;
	            color: #666666;
	            display: -webkit-box;
	            -webkit-box-orient: vertical;
	            -webkit-line-clamp: 2;
	            overflow: hidden;
	            line-height: 24px;
	          }
	        }

	        .content-bottom {
	          width: 100%;
	          display: flex;
	          justify-content: space-between;
	          position: absolute;
	          bottom: 0;

	          span {
	            font-size: 14px;
	            font-weight: 400;
	            color: #666666;
	            line-height: 30px;
	          }

	          button {
	            border: none;
	            background: none;
	            cursor: pointer;
	            color: #1A80FC;
	          }
	        }
	      }
	    }
	  }
	}

	.nomore {
	  line-height: 50px;
	  text-align: center;
	  margin-top: 24px
	  // margin-top:10px;
	}

	.small-title {
	  position: absolute;
	  top: 0;
	  right: 0;
	  width: 45%;
	  height: 25px;
	  background: rgba(0, 0, 0, .5);
	  color: #ffffff;
	  font-size: 9px;
	  font-weight: 500;
	  color: #FFFFFF;
	  line-height: 25px;
	  text-align: center;
	  border-bottom-left-radius: 4px;
	}
</style>
